import Script from 'next/script';
import {useEffect} from 'react';

import styles from './storeFinder.module.css';

const StoreFinder = () => {
  /**
   * Store Rocket init
   */
  function storeRocketInit() {
    StoreRocket.init({
      selector: '.storerocket-store-locator',
      account: 'MN4QB5kJOZ',
    });
  }
  useEffect(() => {
    if (typeof StoreRocket !== 'undefined') {
      storeRocketInit();
    }
  }, []);

  return (<>
    <div
      className={`storerocket-store-locator 
        ${styles.storeFinder_container}`}/>
    <Script
      src='//cdn.storerocket.io/widget.js'
      strategy='lazyOnload'
      onLoad={() => {
        storeRocketInit();
      }}
    />
  </>);
};

export default StoreFinder;
